module.exports = __webpack_public_path__ + "static/media/ilustration-pickup.ab8b27bf.svg";